import { Box, Tooltip } from '@mui/material'
import React from 'react'

import Done from '../../common/icons/done'
import SpinnerIcon from '../../common/icons/spiner'
import { ReactComponent as Planned } from '../../common/icons/hourglassIcon.svg'
import Archive from '../../common/icons/archive'
import { getPercent } from 'src/heplers'

export const TrainingActivityWidget = ({ stats }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // padding: '16px 24px',
        borderRadius: '10px',
        // border: '1px solid #E7E7EE',
        marginBottom: '16px',
        background: '#fff',
        // width: 'calc(70% - 20px)',
        position: 'relative'
      }}
      className='column'
    >
      <div className='row'>
        <Box width={'100%'} display={'flex'} flexDirection={'column'} rowGap={1}>
          <div
            style={{
              width: '100%',
              height: '8px',
              flex: '1',
              borderRadius: '8px',
              overflow: 'hidden',
              marginTop: 16,
              marginBottom: 16,
              backgroundColor: '#ebebeb'
            }}
            className='row row-center'
          >
            {/* <div
              style={{
                width: stats?.expiredPercentage + '%',
                background: '#c7eff4',
                height: '12px',
                borderRadius: '8px',
                position: 'relative',
                border: '3px solid #fff'
              }}
            ></div> */}
            <Tooltip arrow title={'Active'}>
              <div
                style={{
                  width: `${getPercent(stats?.totalCount, stats?.activeCount)}%`,
                  background: 'rgb(27, 27, 38)',
                  height: '12px',
                  borderRadius: '8px',
                  position: 'relative',
                  border: '3px solid #fff'
                  // marginLeft: '-8px'
                }}
              ></div>
            </Tooltip>
            <Tooltip arrow title={'Completed'}>
              <div
                style={{
                  width: `calc(${getPercent(stats?.totalCount, stats?.completedCount + stats?.failedCount)}% + 8px)`,
                  background: 'rgb(0, 188, 98)',
                  height: '12px',
                  borderRadius: '8px',
                  position: 'relative',
                  border: '3px solid #fff',
                  marginLeft: '-8px'
                }}
              ></div>
            </Tooltip>
            <Tooltip arrow title={'Expired'}>
              <div
                style={{
                  width: `calc(${getPercent(stats?.totalCount, stats?.expiredCount)}% + 8px)`,
                  background: 'rgb(240, 40, 76)',
                  height: '12px',
                  borderRadius: '8px',
                  position: 'relative',
                  border: '3px solid #fff',
                  marginLeft: '-8px'
                }}
              ></div>
            </Tooltip>
          </div>
          <Box display={'flex'} columnGap={1} width={'100%'} alignItems={'center'}>
            <Box display={'flex'} sx={{ mr: '10px' }} columnGap={1} alignItems={'center'}>
              {/* <Planned /> */}
              <p
                style={{
                  fontSize: '20px',
                  fontFamily: 'Satoshi'
                }}
              >
                {stats?.totalCount}
              </p>

              <p style={{ fontSize: '15px', fontWeight: 700, color: '#76767F' }}>Total</p>
            </Box>

            <Box display={'flex'} sx={{ mr: '10px' }} columnGap={1} alignItems={'center'}>
              <SpinnerIcon />
              <p
                style={{
                  fontSize: '20px',
                  fontFamily: 'Satoshi'
                }}
              >
                {stats?.activeCount}
              </p>
              <p style={{ fontSize: '14px', color: '#76767F' }}>Active</p>
            </Box>
            <Box display={'flex'} sx={{ mr: '10px' }} columnGap={1} alignItems={'center'}>
              <Done />
              <p
                style={{
                  fontSize: '20px',
                  fontFamily: 'Satoshi'
                }}
              >
                {stats?.completedCount + stats?.failedCount}
              </p>
              <p
                style={{
                  fontSize: '14px',
                  color: '#76767F'
                }}
              >
                Completed
              </p>
            </Box>
            <Box display={'flex'} columnGap={1} alignItems={'center'}>
              <Archive />
              <p
                style={{
                  fontSize: '20px',
                  fontFamily: 'Satoshi'
                }}
              >
                {stats?.expiredCount}
              </p>
              <p
                style={{
                  fontSize: '14px',
                  color: '#76767F'
                }}
              >
                Expired
              </p>
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  )
}
